export function init() {

	// Handle click of mega nav hovered panel --------------------------------------------------------- //

	const megaNavCats = document.querySelectorAll('.product-meganav .category');
	megaNavCats.forEach((el) => {
		el.addEventListener('click', (e) => {
			if (e.target.tagName == 'DIV') {
				e.target.querySelector('a:first-child').click();
			}
		});
	});

	// Toggle region nav in header -------------------------------------------------------------------- //

	const toggleRegionNav = () => {
		document.querySelector('.region-nav').classList.toggle('-visible');
		document.querySelector('.toggle-region-nav').classList.toggle('-visible');
	}

	if (document.querySelector('.toggle-region-nav')) {
		document.querySelector('.toggle-region-nav').addEventListener('click', (e) => {
			e.preventDefault();

			toggleRegionNav();

			if (document.querySelector('.product-meganav').classList.contains('-visible')) {
				toggleProductMeganav();
			}
		});
	}

	// Toggle product meganav in header --------------------------------------------------------------- //

	const toggleProductMeganav = () => {
		document.querySelector('.product-meganav').classList.toggle('-visible');
		document.querySelector('.toggle-product-meganav').classList.toggle('-visible');
	}

	if (document.querySelector('.toggle-product-meganav')) {
		document.querySelector('.toggle-product-meganav').addEventListener('click', (e) => {
			e.preventDefault();

			toggleProductMeganav();

			if (document.querySelector('.region-nav').classList.contains('-visible')) {
				toggleRegionNav();
			}

			if (document.querySelector('.mobile-nav').classList.contains('-visible')) {
				toggleMobileNav();
			}

		});
	}

	// Toggle mobile nav in header -------------------------------------------------------------------- //

	const toggleMobileNav = () => {
		document.querySelector('.mobile-nav').classList.toggle('-visible');
		document.querySelector('.toggle-mobile-nav').classList.toggle('-visible');
	}

	if (document.querySelector('.toggle-mobile-nav')) {
		document.querySelector('.toggle-mobile-nav').addEventListener('click', (e) => {
			e.preventDefault();

			toggleMobileNav();

			if (document.querySelector('.product-meganav').classList.contains('-visible')) {
				toggleProductMeganav();
			}
		});
	}

	// Mobile region selector ------------------------------------------------------------------------- //

	if (document.querySelector('.mobile-select-region')) {
		document.querySelector('.mobile-select-region').addEventListener('change', (e) => {
			window.location = e.target.value;
		})
	}

	window.onscroll = function () { myFunction() };
	
	var navbar = document.getElementById("navbar");

	var sticky = navbar.offsetTop;

	function myFunction() {
		if (window.pageYOffset >= sticky) {
		  navbar.classList.add("sticky")
		} else {
		  navbar.classList.remove("sticky");
		}
	}
}
